module.exports = __webpack_public_path__ + "static/media/braces.b9b6210e.svg";